// бекап настроек 
export function exportSettings() {
    const a = document.createElement("a");
    const data = localStorage.getItem("clusterflyDash");
    a.href = window.URL.createObjectURL(new Blob([data], { type: "text/plain" }));
    a.download = "clusterflyDashBackup.txt";
    a.click();
}